'use client';

import {cn} from '@/lib/utils';
import {useTranslations} from 'next-intl';
import {useEffect, useState} from 'react';

type MediaPreviewProps = {
  refresh?: number;
};
export default function IModal({refresh}: MediaPreviewProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [url, setUrl] = useState('');
  const t = useTranslations('Utils');

  const showModal = (e: any) => {
    if (e.target.dataset.modal) {
      setUrl(e.target.dataset.modal);
      setIsOpen(!isOpen);
      e.preventDefault();
    }
  };
  useEffect(() => {
    document.querySelectorAll('[data-modal]')?.forEach((mediaElement) => {
      mediaElement.removeEventListener('click', showModal);
      mediaElement.addEventListener('click', showModal);
    });
  }, []);

  return (
    isOpen && (
      <div className="fixed w-full h-screen z-[999] top-0 flex flex-col items-center justify-center">
        <div className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50"></div>
        <div
          className={cn(
            'max-w-[calc(100%-2rem)] md:max-w-[60vw]',
            'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full  translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 outline-none '
          )}
        >
          <div className="flex flex-col gap-2 text-center sm:text-left">
            <h2 className="text-lg leading-none font-semibold"></h2>
          </div>
          <div className="h-[70vh]">
            <iframe className="aspect-video w-full h-[70vh]" src={url} />
          </div>
          <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[&gt;svg]:px-3"
              type="button"
              onClick={() => setIsOpen(false)}
            >
              {t('cancel')}
            </button>
          </div>
          <button
            type="button"
            className="ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"
          >
            <span className="sr-only">Close</span>
          </button>
        </div>
      </div>
    )
  );
}
